
/**
 * **カードが動いた**（Issue #537。1 試合で 59 件 —— 素材・墓地送り・バウンス・除外の全部）。
 *
 * 開く: `move`。**出どころで光って、行き先で着地する**。
 *
 * **素材として動いたときは出さない**（`payload.isMaterial`）—— シンクロ・融合の素材は
 * 召喚の演出がまとめて見せるので、1 枚ずつ光ると散る（旧 `components/fx` の
 * `showsGraveEffect` と同じ判断）。**演出は `REASON_*` の数値を知らない**。
 */
const COLOR = '#c8d0e0';

/** 状況ごとのファイル（`../effects/move_<variant>_effect.js`）が共有する組み立て（Issue #628。arcade はどの状況も同じ絵） */
export const spec = {
  label: 'カードの移動',
  color: COLOR,

  opens({ payload }) {
    if (payload?.isMaterial) return null;
    // 出どころも行き先も分からなければ出さない
    return payload?.zone || payload?.fromZone ? payload : null;
  },

  layers: [
    {
      id: 'from',
      label: '出どころの光',
      part: 'glow',
      at: { zone: '{fromZone}', else: { zone: '{zone}' } },
      props: { color: COLOR },
      tf: {
        scale: { keys: [{ ms: 0, value: 0.7 }, { ms: 260, value: 1.6, ease: 'ease_out' }] },
        opacity: { keys: [{ ms: 0, value: 0.85 }, { ms: 320, value: 0 }] },
      },
    },
    {
      id: 'to',
      label: '行き先の着地',
      part: 'ring',
      at: { zone: '{zone}', else: { zone: '{fromZone}' } },
      props: { color: COLOR, width: 4 },
      tf: {
        scale: { keys: [{ ms: 180, value: 0.4 }, { ms: 520, value: 1.6, ease: 'ease_out' }] },
        opacity: { keys: [{ ms: 180, value: 0 }, { ms: 260, value: 0.9 }, { ms: 560, value: 0 }] },
      },
    },
  ],
};
